import { formatNumber } from '@/utils/number';

interface StatementAmountCellProps {
  value: number;
}

export function StatementAmountCell({ value }: StatementAmountCellProps) {
  return <span className="tabular-nums">{formatNumber(value)}</span>;
}
